import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { GET_SCHEDULERS_INBOX_QUERY_KEY } from './useGetScheduledInboxReports.query';

const useRemoveInboxSchedulerInboxQuery = (id: string) => {
  const queryClient = useQueryClient();
  const { isLoading, mutateAsync } = useMutation(() => api.delete(API_URL.REPORTS_RESULTS_BY_ID(id)), {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_SCHEDULERS_INBOX_QUERY_KEY],
      });
    },
  });

  return {
    isLoading,
    handleSubmit: mutateAsync,
  };
};

export default useRemoveInboxSchedulerInboxQuery;
